import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { Checkbox } from '../../ui/checkbox';
import { FieldLabel, FieldHint } from './fields';

/** Step 4 — what the booker sees: brand colour, confirmation and questions. */
export default function OthersSection({ form, setForm }) {
    const [newQuestion, setNewQuestion] = useState('');

    const addQuestion = () => {
        if (!newQuestion.trim()) return;
        setForm({ ...form, custom_questions: [...form.custom_questions, { label: newQuestion.trim(), required: false }] });
        setNewQuestion('');
    };

    const removeQuestion = (idx) => {
        setForm({ ...form, custom_questions: form.custom_questions.filter((_, i) => i !== idx) });
    };

    return (
        <div className="space-y-5">
            <div>
                <FieldLabel htmlFor="bl-color-hex">Brand Color</FieldLabel>
                <div className="flex items-center gap-2 mt-1.5 max-w-xs">
                    <input type="color" value={form.color} onChange={e => setForm({ ...form, color: e.target.value })} className="w-10 h-10 rounded cursor-pointer border-0" aria-label="Pick brand color" data-testid="bl-color" />
                    <Input id="bl-color-hex" value={form.color} onChange={e => setForm({ ...form, color: e.target.value })} className="flex-1" />
                </div>
                <FieldHint>Used on this link's public booking page.</FieldHint>
            </div>

            <div>
                <FieldLabel htmlFor="bl-confirmation-message">Confirmation Message</FieldLabel>
                <Textarea id="bl-confirmation-message" value={form.confirmation_message} onChange={e => setForm({ ...form, confirmation_message: e.target.value })} rows={2} className="mt-1.5" data-testid="bl-confirmation-message" />
                <FieldHint>Shown to the booker once their meeting is confirmed.</FieldHint>
            </div>

            <div>
                <FieldLabel className="mb-1.5 block" htmlFor="bl-new-question">Custom Questions</FieldLabel>
                {form.custom_questions.map((q, i) => (
                    <div key={i} className="flex items-center gap-2 mb-2 rounded-lg border border-stone-200 px-3 py-2">
                        <span className="text-sm flex-1 text-stone-700">{q.label}</span>
                        <label className="flex items-center gap-1 text-xs text-stone-500">
                            <Checkbox checked={q.required} onCheckedChange={(v) => {
                                const qs = [...form.custom_questions];
                                qs[i] = { ...qs[i], required: v };
                                setForm({ ...form, custom_questions: qs });
                            }} /> Required
                        </label>
                        <button type="button" onClick={() => removeQuestion(i)} className="text-red-400 hover:text-red-600" aria-label={`Remove question: ${q.label}`}><X className="w-3.5 h-3.5" /></button>
                    </div>
                ))}
                <div className="flex gap-2">
                    <Input id="bl-new-question" value={newQuestion} onChange={e => setNewQuestion(e.target.value)} placeholder="e.g. What would you like to discuss?" className="flex-1 text-sm" onKeyDown={e => e.key === 'Enter' && addQuestion()} data-testid="bl-new-question" />
                    <Button variant="outline" size="sm" onClick={addQuestion} type="button">Add</Button>
                </div>
            </div>
        </div>
    );
}
